/**
 * New paper before a paper can be made: what a paper is written from, the two things it waits
 * for as a checklist (readiness.ts), and the button, disabled. The same label as the form, so
 * "New paper" is found in both states.
 */
import { PILL, type Readiness, type ReadinessRow } from "./readiness";

type Props = {
  readiness: Readiness;
  onCheckChapters: (bookId: string) => void;
  onCheckFormat: () => void;
};

export function PaperReadiness({ readiness, onCheckChapters, onCheckFormat }: Props) {
  const act = (row: ReadinessRow) => {
    if (row.action?.to === "review") onCheckChapters(row.action.bookId);
    else if (row.action?.to === "format") onCheckFormat();
  };
  return (
    <section className="panel new-paper" aria-label="New paper">
      <h2>New paper</h2>
      <p className="panel__text">
        A paper is written from your textbook, in the format of your past papers.
      </p>
      <ul className="readiness">
        {readiness.rows.map((row) => (
          <li key={row.name} className="readiness__row">
            <span className="readiness__name">{row.name}</span>
            <span className={`pill pill--${PILL[row.kind].kind}`}>{PILL[row.kind].label}</span>
            {row.action ? (
              <button
                type="button"
                className="subject__link readiness__text"
                onClick={() => act(row)}
              >
                {row.text}
              </button>
            ) : (
              <span className="readiness__text">{row.text}</span>
            )}
          </li>
        ))}
      </ul>
      <button className="button button--primary new-paper__make" disabled>
        Make a paper
      </button>
    </section>
  );
}
